import { Injectable, signal } from '@angular/core';

/**
 * Servizio globale per gestire lo stato di loading dell'applicazione
 * Traccia il numero di richieste HTTP in corso
 */
@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  // Numero di richieste HTTP attualmente in corso
  private requestCount = signal(0);
  
  // Stato pubblico: true se ci sono richieste in corso
  public isLoading = signal(false);

  /**
   * Incrementa il contatore delle richieste e attiva il loading
   */
  show(): void {
    this.requestCount.update(count => count + 1);
    this.isLoading.set(true);
  }

  /**
   * Decrementa il contatore delle richieste
   * Disattiva il loading solo quando tutte le richieste sono completate
   */
  hide(): void {
    this.requestCount.update(count => {
      const newCount = Math.max(0, count - 1);
      if (newCount === 0) {
        this.isLoading.set(false);
      }
      return newCount;
    });
  }

  /**
   * Reset forzato dello stato di loading (utile per gestione errori critici)
   */
  reset(): void {
    this.requestCount.set(0);
    this.isLoading.set(false);
  }
}
